import type { NativeAgent } from "@rally/agreed";
import { Col, Icon, Stack, Text, useTheme } from "@rally/ui-kit";
import { useEffect, useState } from "react";
import { formatList } from "../localization/format.ts";
import { say } from "../localization/say.ts";
import { read } from "../net/rally.ts";

export function WhatTheServerDoes() {
  const theme = useTheme();
  const [native, setNative] = useState<NativeAgent[]>([]);

  useEffect(() => {
    void read<{ native: NativeAgent[] }>("agents").then((answer) => setNative(answer?.native ?? []));
  }, []);

  const titleOf = (agent: NativeAgent) =>
    agent.handle === "labeller" ? say("native.labeller.title") : agent.title;
  const doesOf = (agent: NativeAgent) =>
    agent.handle === "labeller" ? say("native.labeller.does") : agent.does;
  const actOf = (act: string) => (act === "conversation.label" ? say("action.conversationLabel") : act);

  if (native.length === 0) return null;

  return (
    <Stack gap={3}>
      <Text typeName="title">{say("server.does.title")}</Text>
      <Text typeName="caption" color="text.secondary">
        {say("server.does.what")}
      </Text>

      {native.map((agent) => (
        <Col
          key={agent.handle}
          testID={`server-does-${agent.handle}`}
          style={{
            gap: theme.space[2],
            paddingVertical: theme.space[3],
            borderTopWidth: 1,
            borderTopColor: theme.color["border.default"],
          }}
        >
          <Text typeName="body" color="text.primary">
            {titleOf(agent)}
          </Text>

          <Text typeName="caption" color="text.secondary">
            {doesOf(agent)}
          </Text>

          <Col style={{ flexDirection: "row", alignItems: "center", gap: theme.space[2] }}>
            <Icon name="shield" size={14} color="text.tertiary" />
            <Text typeName="caption" color="text.tertiary">
              {agent.acts.length ? formatList(agent.acts.map(actOf)) : say("agents.acts.none")}
            </Text>
          </Col>

          {agent.readsMessages ? (
            <Col style={{ flexDirection: "row", alignItems: "center", gap: theme.space[2] }}>
              <Icon name="eye" size={14} color="text.tertiary" />
              <Text typeName="caption" color="text.tertiary">
                {agent.sendsTextAway ? say("agents.reads.away") : say("agents.reads.here")}
              </Text>
            </Col>
          ) : null}
        </Col>
      ))}
    </Stack>
  );
}
